// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function externalBrazilOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: 'pagaleve',
  };
}
